<template>
  <div style="position: absolute;">
    <input ref="hiddenFileInput" :accept="validUploadTypes" type="file" style="display:none;" @change="uploadFileFromInput">

    <div v-if="dragging" class="overlay-dropzone"
        @click="onClick"
        @drop.stop.prevent="onDrop"
        @dragover.stop.prevent="onDragOver"
        @dragenter.stop.prevent="onDragEnter"
        @dragleave.stop.prevent="onDragLeave">
      <i v-if="disabled" style="pointer-events:none" class="fas fa-exclamation-triangle"/>
      <i v-else style="pointer-events:none" class="fas fa-upload"/>
      <div style="pointer-events:none">
        <div v-if="disabled">Design is locked.</div>
        <div v-else>Upload Image or Logo</div>
      </div>
    </div>
  </div>
</template>

<script>

  import {mapGetters} from 'vuex';
  import filestackClient from '@/lib/filestackClient';

  export default{
    props: ['bus', 'disabled'],

    data(){
      return {
        filestackDialogOpen: false,
        dragging: false
      }
    },

    computed: {
      ...mapGetters(['flags', 'validUploadTypes', 'validUploadTypeText']),
      dragEnabled() {
        return !this.disabled && !this.filestackDialogOpen
      }
    },

    methods:{
      uploadFile(file){
        if (this.validUploadTypes.split(',').includes(file.type)) {
          const reader = new FileReader();

          reader.onload = (f) => {
            const data = f.target.result;
            this.bus.$emit('imageDataUploadedEvent', data)
          };

          reader.readAsDataURL(file);
        } else {
          let evt = {
            droppedType: file.type,
            allowedTypes: this.validUploadTypes,
            allowedText: this.validUploadTypeText,
          }
          this.$emit('drop-fail', evt);
        }
      },
      onDrop(evt) {
        if (this.dragEnabled){
          this.uploadFile(evt.dataTransfer.files[0]);
        }
        this.dragging = false;
      },
      onDragOver(evt) {
      },
      onDragEnter() {
        if (this.dragEnabled) {
          this.dragging = true;
        }
      },
      onClick() {
        // Allow user to recover from any weirdness thaat leaves dropzone over the top
        this.dragging = false;
      },
      onDragLeave() {
        this.dragging = false;
      },
      uploadFileFromInput(event){
        this.uploadFile(event.target.files[0]);
      },
      async uploadFileFromFileStack(blob){
        var reader = new FileReader();
        reader.onloadend = () => {
          const data = reader.result;
          this.bus.$emit('imageDataUploadedEvent', data);
        }
        reader.readAsDataURL(blob);
      },
    },

    events:{
      async showUploadDialog() {
        if (this.flags.filestackUpload){
          let client = await filestackClient();
          client.picker({
            onOpen:() => {
              this.filestackDialogOpen = true;
            },
            onClose:() => {
              this.filestackDialogOpen = false;
            },
            onFileUploadFinished : async (response) => {
              const blob = await client.retrieve(response.handle);
              this.uploadFileFromFileStack(blob);
            }}).open();
        }
        else{
          this.$refs.hiddenFileInput.click();
        }
      },

      // filestack dialog can be externally opened and closed from via EditorControlsOverlay
      filestackDialogOpen(){
        this.filestackDialogOpen = true;
      },
      filestackDialogClosed() {
        this.filestackDialogOpen = false;
      }
    },

    mounted() {
      this.dragging = false;
      document.body.addEventListener('dragenter', this.onDragEnter);
    },

    beforeDestroy(){
      document.body.removeEventListener('dragenter', this.onDragEnter);
    }
  }

</script>

<style lang="scss" scoped>
  .overlay-dropzone {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 11;
    background-color: rgba(0,0,0,0.5);
    text-align: center;
    color: white;
    font-size: 30vh;
    line-height: 70vh;
    div {
      font-size: 8vh;
      line-height: 30vh;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/editor/ImageUploadDropzone.vue